import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { GestAuthProvider, useGestAuth } from "./GestAuthContext";
import GestLogin from "./GestLogin";
import GestLayout from "./GestLayout";
import GestDashboard from "./GestDashboard";
import GestCantieri from "./GestCantieri";
import GestCantiereDetail from "./GestCantiereDetail";
import GestAvanzamento from "./GestAvanzamento";
import GestUtenti from "./GestUtenti";
import GestDocumenti from "./GestDocumenti";
import GestSettings from "./GestSettings";

/** Route guard: only allow users whose role is in the given list. */
function RoleGuard({ allow, children }) {
  const { user } = useGestAuth();
  if (user === null) return <div className="p-8 text-[#6e6e73]">Caricamento…</div>;
  if (!user) return <Navigate to="/gestione/login" replace />;
  if (!allow.includes(user.role)) return <Navigate to="/gestione" replace />;
  return children || <Outlet />;
}

/** Landing route: sends every role to a page they can actually use. */
function GestHome() {
  const { user } = useGestAuth();
  if (user === null) return <div className="p-8 text-[#6e6e73]">Caricamento…</div>;
  if (!user) return <Navigate to="/gestione/login" replace />;
  if (user.role === "admin" || user.role === "ufficio") return <GestDashboard />;
  if (user.role === "produzione") return <Navigate to="/gestione/produzione" replace />;
  if (user.role === "posa") return <Navigate to="/gestione/posa" replace />;
  return <Navigate to="/gestione/cantieri" replace />;
}

export default function GestApp() {
  return (
    <GestAuthProvider>
      <Routes>
        <Route path="login" element={<GestLogin />} />
        <Route element={<GestLayout />}>
          <Route index element={<GestHome />} />
          <Route path="cantieri" element={<GestCantieri />} />
          <Route path="cantieri/:id" element={<GestCantiereDetail />} />
          <Route
            path="produzione"
            element={
              <RoleGuard allow={["admin", "ufficio", "produzione"]}>
                <GestAvanzamento mode="produzione" />
              </RoleGuard>
            }
          />
          <Route
            path="posa"
            element={
              <RoleGuard allow={["admin", "ufficio", "posa"]}>
                <GestAvanzamento mode="posa" />
              </RoleGuard>
            }
          />
          <Route
            path="documenti"
            element={
              <RoleGuard allow={["admin", "ufficio"]}>
                <GestDocumenti />
              </RoleGuard>
            }
          />
          <Route
            path="utenti"
            element={
              <RoleGuard allow={["admin"]}>
                <GestUtenti />
              </RoleGuard>
            }
          />
          <Route
            path="impostazioni"
            element={
              <RoleGuard allow={["admin"]}>
                <GestSettings />
              </RoleGuard>
            }
          />
          <Route path="*" element={<Navigate to="/gestione" replace />} />
        </Route>
      </Routes>
    </GestAuthProvider>
  );
}
